import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RaisedButton, FlatButton } from 'material-ui';
import { FileCloudUpload } from 'material-ui/svg-icons';
import { DropTarget } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { colors } from '../../utils';

// DnD Spec
const dropTargetSpec = {
  drop(props, monitor, component) {
    const { files } = monitor.getItem();
    component.loadFiles(files);
  },
};

// Dnd Collector
function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

class SignatureUpload extends React.Component {
  static propTypes = {
    onFilesLoaded: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isOver: PropTypes.bool.isRequired,
    text: PropTypes.string,
    accept: PropTypes.string,
    buttonLabel: PropTypes.string,
  }

  static defaultProps = {
    text: 'Drop signature image here',
    accept: 'image/*',
    buttonLabel: 'Select a File',
  }

  state = {
    file: null,
    preview: null,
  }

  loadFile(file) {
    const reader = new FileReader();

    reader.onload = () => {
      this.props.onFilesLoaded(reader.result, file);
      this.setState({
        file,
        preview: reader.result,
      });
    };

    reader.readAsDataURL(file);
  }

  clearFiles() {
    this.setState({ file: null, preview: null });
    if (this.props.onClear) this.props.onClear();
  }

  renderUploadUI() {
    if (this.state.file) return null;
    const { text, accept, buttonLabel } = this.props;
    return (
      <Fragment>
        <FileCloudUpload className="mb-1" style={{ width: 48, height: 48 }} color={colors.blue} />
        <DropzonePrimaryLabel>{text}</DropzonePrimaryLabel>
        <DropzoneSecondaryLabel className="mb-2">or</DropzoneSecondaryLabel>
        <RaisedButton primary label={buttonLabel} onClick={() => this.fileBtnRef.click()} />
        <input
          style={{ display: 'none' }}
          ref={(ref) => { this.fileBtnRef = ref; return true; }}
          type="file"
          accept={accept}
          onChange={e => this.loadFile(e.target.files[0])}
        />
      </Fragment>
    );
  }

  renderConfirmation() {
    if (!this.state.file) return null;
    return (
      <Fragment>
        {this.state.preview && (
          <SignaturePreviewWrapper>
            <SignaturePreview src={this.state.preview} alt="signature-preview" />
          </SignaturePreviewWrapper>
        )}
        <FlatButton
          primary
          label="Clear"
          onClick={() => this.clearFiles()}
        />
      </Fragment>
    );
  }

  render() {
    return this.props.connectDropTarget((
      <span>
        <UploadDropzone isOver={this.props.isOver} className="mb-4">
          {this.renderUploadUI()}
          {this.renderConfirmation()}
        </UploadDropzone>
      </span>
    ));
  }
}


const UploadDropzone = styled.div`
  width: 100%;
  height: 220px;
  background: ${props => (props.isOver ? 'white' : colors.gray)};
  border: dashed .25rem ${colors.blue};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s linear;
`;

const DropzonePrimaryLabel = styled.div`
  font-size: 1.125rem;
  color: black;
`;

const DropzoneSecondaryLabel = styled.div`
  font-size: 1rem;
`;

const SignaturePreviewWrapper = styled.div`
  height: 130px;
`;

const SignaturePreview = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export default DropTarget([NativeTypes.FILE], dropTargetSpec, collect)(SignatureUpload);
